import { Reveal } from "@/components/Reveal";

const articles = [
    {
        numeral: "I",
        title: "The Vault — Client Confidentiality",
        body: "All footage, brand assets, and campaign materials entrusted to Vellor Studio are held under absolute confidentiality. Nothing leaves the atelier: no material is shared, repurposed, referenced, or publicly acknowledged without the client's written consent.",
        testid: "policy-article-vault",
    },
    {
        numeral: "II",
        title: "Structured Delivery Timelines",
        body: "Every commission is governed by a mutually ratified timeline — milestone-based, documented, and honored without exception. Delivery dates at Vellor Studio are commitments, not estimates, and any deviation is communicated before it is felt.",
        testid: "policy-article-timelines",
    },
    {
        numeral: "III",
        title: "Project Boundaries",
        body: "The scope of each commission is defined before the first frame is cut. Deliverables are itemized, revisions are structured within the agreed mandate, and work beyond that mandate is quoted separately — ensuring clarity, fairness, and zero ambiguity on either side.",
        testid: "policy-article-boundaries",
    },
];

const Policy = () => (
    <section
        id="policy"
        data-testid="vellor-policy-section"
        className="relative overflow-hidden px-6 py-32 sm:py-40 lg:px-16 lg:py-52"
    >
        <div className="royal-flare absolute inset-x-0 top-0 h-[50vh] opacity-70" />

        <div className="relative mx-auto max-w-6xl">
            <Reveal>
                <p className="mb-8 font-display text-[10px] uppercase tracking-[0.5em] text-[#270057]">
                    Terms of the Atelier
                </p>
                <h2
                    data-testid="vellor-policy-title"
                    className="font-serif text-4xl font-normal tracking-[-0.01em] text-[#270057] sm:text-5xl lg:text-6xl"
                >
                    Vellor Policy
                </h2>
                <div className="royal-rule mt-12 w-24" />
            </Reveal>

            <div className="mt-24 lg:mt-32">
                {articles.map((a, i) => (
                    <Reveal key={a.numeral} delay={i * 0.12}>
                        <div
                            data-testid={a.testid}
                            className="group grid grid-cols-1 gap-6 border-t border-[#270057]/15 py-14 transition-colors duration-700 hover:border-[#270057]/40 md:grid-cols-12 md:items-baseline"
                        >
                            <span className="font-serif text-4xl font-normal italic text-[#270057] transition-colors duration-700 group-hover:text-[#270057] md:col-span-2">
                                {a.numeral}.
                            </span>
                            <h3 className="font-serif text-2xl font-medium text-[#270057] md:col-span-4 lg:text-3xl">
                                {a.title}
                            </h3>
                            <p className="max-w-xl text-base font-normal leading-relaxed text-[#270057] md:col-span-6 md:text-base">
                                {a.body}
                            </p>
                        </div>
                    </Reveal>
                ))}
                <div className="border-t border-[#270057]/15" />
            </div>
        </div>
    </section>
);

export default Policy;
